import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-simple-receipt',
  templateUrl: './simple-receipt.component.html',
  styleUrls: ['./simple-receipt.component.css']
})
export class SimpleReceiptComponent implements OnInit {

  public menu_item_id = '98';
  public add_auth;

  no = '';
  type = '';
  invoice_no = '';
  private dp = [];
  accts = [];

  total = 0;
  total_amount = 0;

  displayedColumns = ['choose', 'invoice_no', 'total', 'invoice_date', 'paid_amount', 'remain_amount'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  flag = false;
  allUnChecked = false;

  model = {
    'receipt_type': 'cash_receipt', 'rec_no': '', 'date': new Date(), 'paid': '', 'payment_method': '',
    'acct_number': '', 'cost_center': '0', 'bank_account_no': '', 'comment': '', 'total': '',
    'amount': '', 'bank_amount': '', 'check_no': '', 'flag': 'new', 'no': '0', 'year': '',
    'id': '0', 'bank_account': '', 'receipt_acct_id': '0', 
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id
  };

  cash_receipt_model = {
    'table_name': 'cash_receipt', 'cash_receipt_id': '0', 'cash_receipt_no': '', 'account_type': '', 'acct_name': '',
    'to_acct': '0', 'receipt_no': '', 'no': '0', 'year': '', 'receipt_date': '', 'acct_number': '', 'paid': '',
    'payment_method': '', 'check_no': '', 'flag': 'new', 'key': 'cash_receipt_id', 'cost_center': '0', 'bank_account_no': '',
    'comment': '', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'receipt_type': 'simple'
  };

  payment_voucher_model = {
    'table_name': 'payment_voucher', 'payment_voucher_id': '0', 'payment_voucher_no': '', 'account_type': '',
    'acct_name': '', 'from_acct': '0', 'voucher_no': '', 'no': '0', 'year': '', 'voucher_date': '',
    'acct_number': '', 'paid': '', 'check_no': '', 'flag': 'new', 'key': 'payment_voucher_id', 'payment_method': '',
    'cost_center': '0', 'bank_account_no': '', 'comment': '', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id,
    'voucher_type': 'simple'
  };

  from_acct = {
    sub_acct_name: "", sub_acct_name_en: "", sub_acct_id: '0', acct_number: '', mobile: '',
    account_type: ''
  };

  search_obj = {
    'placeholder': 'اسم الحساب/ رقم الحساب/ رقم الجوال', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile'],
      'condition': " AND (`branch_id` = '" + this.model['branch_id'] +
      "' OR `branch_id` = '0') AND `is_account` = '1' AND `customer`.`agent_acct_number` = ''"
    },
    {
      'table_name': '`supplier`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'supplier_name', 'supplier_name_en', 'mobile'],
      'condition': " AND (`branch_id` = '" + this.model['branch_id'] +
      "' OR `branch_id` = '0')  AND `is_account` = '1'"
    }]
  };

  // ,
  //   {
  //     'table_name': '`employee`', 'selected_no': 'employee_no',
  //     'field_list': ['employee_no', 'name', 'name_en']
  //   }

  search_customer = {
    'placeholder': 'اسم العميل/ رقم العميل/ رقم الجوال', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile'],
      'condition': " AND (`branch_id` = '" + this.model['branch_id'] +
      "' OR `branch_id` = '0') AND `is_account` = '1'"
    }]
  };

  search_supplier = {
    'placeholder': 'اسم المورد/ رقم المورد/ رقم الجوال', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`supplier`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'supplier_name', 'supplier_name_en', 'mobile'],
      'condition': " AND (`branch_id` = '" + this.model['branch_id'] +
      "' OR `branch_id` = '0')  AND `is_account` = '1'"
    }]
  };

  cost_centers = [];
  supplierList = [];
  cashAcctList = [];
  bankAcctList = [];
  acct_id_list = [];

  acct_detail = '';
  cash_detail = '';
  bank_detail = '';
  saveClicked = false;

  Customer_Placeholder; Supplier_Placeholder;
  Success_Msg; Error_Msg; Acct_Placeholder2; Acct_Msg; Casher_Acct_Msg;
  Bank_Acct_Msg; Rec_Type_Msg; Rec_Amount_Msg; Rec_Total_Msg;
  Rec_No_Msg; Payment_Method_Msg; Rec_No_Exist_Msg; Not_Counter_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants, private queryList: QueryList,
    private router: Router, private route: ActivatedRoute, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Acct_Placeholder2').subscribe((res: string) => {
      this.Acct_Placeholder2 = res;
    });
    this.search_obj['placeholder'] = this.Acct_Placeholder2;

    translate.get('Customer_Placeholder').subscribe((res: string) => {
      this.Customer_Placeholder = res;
    });
    this.search_customer['placeholder'] = this.Customer_Placeholder;

    translate.get('Supplier_Placeholder').subscribe((res: string) => {
      this.Supplier_Placeholder = res;
    });
    this.search_supplier['placeholder'] = this.Supplier_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Rec_Type_Msg').subscribe((res: string) => {
      this.Rec_Type_Msg = res;
    });

    translate.get('Rec_Amount_Msg').subscribe((res: string) => {
      this.Rec_Amount_Msg = res;
    });

    translate.get('Rec_Total_Msg').subscribe((res: string) => {
      this.Rec_Total_Msg = res;
    });

    translate.get('Rec_No_Msg').subscribe((res: string) => {
      this.Rec_No_Msg = res;
    });

    translate.get('Acct_Msg').subscribe((res: string) => {
      this.Acct_Msg = res;
    });

    translate.get('Bank_Acct_Msg').subscribe((res: string) => {
      this.Bank_Acct_Msg = res;
    });

    translate.get('Casher_Acct_Msg').subscribe((res: string) => {
      this.Casher_Acct_Msg = res;
    });

    translate.get('Payment_Method_Msg').subscribe((res: string) => {
      this.Payment_Method_Msg = res;
    });

    translate.get('Rec_No_Exist_Msg').subscribe((res: string) => {
      this.Rec_No_Exist_Msg = res;
    }); 

    translate.get('Not_Counter_Msg').subscribe((res: string) => {
      this.Not_Counter_Msg = res;
    })
  }

  ngOnInit() {
    let obj;

    // get leaf cashier accts
    let parent_acct = this.applicationConstants.main_acct_config['cash'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.cashAcctList = data.data['list'];
      });

    // get leaf bank accts
    parent_acct = this.applicationConstants.main_acct_config['bank'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.bankAcctList = data.data['list'];
      });

    let query = this.queryList.all_costCenter;
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.cost_centers = data.data['list'];

        let costObj = { 'cc_id': '0', 'cc_number': '0', 'cc_name': 'الرئيسي', 'cc_name_en': 'Main' };
        this.cost_centers.unshift(costObj);
      });

    this.getReceipt();
  }

  getReceipt() {
    this.route.params.subscribe(params => {
      let query, obj;

      if (params['no'] != undefined && params['type'] != undefined) {
        this.no = params['no'];
        this.type = params['type'];

        (document.getElementById('cash_receipt') as HTMLInputElement).disabled = true;
        (document.getElementById('payment_voucher') as HTMLInputElement).disabled = true;

        let name, acct;
        if (this.type == 'cash_receipt') {
          name = 'receipt';
          acct = 'to_acct';
          this.cash_receipt_model['cash_receipt_no'] = this.no;
        }
        else if (this.type == 'payment_voucher') {
          name = 'voucher';
          acct = 'from_acct';
          this.payment_voucher_model['payment_voucher_no'] = this.no;
        }

        this.model['receipt_type'] = this.type;

        if (this.no != '') {

          /////////////////////////////////  Get Receipt Detail /////////////////////////////////

          let receipt_detail = [];
          query = "SELECT `" + this.type + "`.* FROM `" + this.type + "` WHERE " +
            "`" + this.type + "`.`" + this.type + "_no` = '" + this.no + "' AND `status` != '0'";
          
          obj = { cmd: 'getList', query: query };
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              receipt_detail = data.data['list'][0];
              this.model['rec_no'] = receipt_detail[name + '_no'];
              this.model['date'] = new Date(receipt_detail[name + '_date']);

              if (receipt_detail[acct] != '') {
                query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + receipt_detail[acct] + "'";
                obj = { cmd: 'getList', query: query };

                this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                  .subscribe(data => {
                    this.applicationConstants.appComp.hideBusyCursor();

                    let result = data.data['list'][0];
                    //let htmlElement;

                    if (receipt_detail['payment_method'] == 'cash') {
                      this.cash_detail = result['sub_acct_name'] + '-' + result['sub_acct_name_en'] + '-' +
                        result['acct_number'];
                    }
                    else {
                      this.bank_detail = result['sub_acct_name'] + '-' + result['sub_acct_name_en'] + '-' +
                        result['acct_number'];

                      this.model['bank_account_no'] = receipt_detail[acct];
                    }
                  });
              }

              this.model['paid'] = receipt_detail['paid'];
              this.model['cost_center'] = receipt_detail['cost_center'];
              this.model['payment_method'] = receipt_detail['payment_method'];
              this.model['comment'] = receipt_detail['comment'];
              this.model['flag'] = 'update';
              this.model['no'] = receipt_detail['no'];
              this.model['year'] = receipt_detail['year'];
              this.model['id'] = receipt_detail[this.type + '_id'];
              this.model['total'] = this.model['paid'];
              this.model['bank_account'] = receipt_detail[acct];
              this.model['acct_number'] = receipt_detail[acct];
              this.model['check_no'] = receipt_detail['check_no'];


              /////////////////////////////////  Get Acct Detail /////////////////////////////////

              query = "SELECT * FROM `" + receipt_detail['account_type'] + "` WHERE `acct_number` = '"
                + receipt_detail['acct_number'] + "' AND `status` = '1'";
              obj = { cmd: 'getList', query: query };
              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                  let acct_detail = data.data['list'];
                  console.log(acct_detail);
                  this.from_acct.acct_number = acct_detail[0]['acct_number'];
                  this.from_acct.account_type = receipt_detail['account_type'];
                  this.from_acct.sub_acct_name = acct_detail[0]['acct_number'] + ' - ' + acct_detail[0][receipt_detail['account_type'] + '_name'] + ' - ' +
                  acct_detail[0][receipt_detail['account_type'] + '_name_en'];

                  this.acct_detail = this.from_acct.sub_acct_name;

                  if (this.type == 'cash_receipt') 
                    (document.getElementById('search_value_0') as HTMLInputElement).disabled = true;
                  else if (this.type == 'payment_voucher')
                    (document.getElementById('search_value_1') as HTMLInputElement).disabled = true;

                  /////////////////////////////////  Get Invoice List /////////////////////////////////

                  this.getInvoiceList();
                });
            });

            /////////////////////////////////  Get Receipt Acct ID /////////////////////////////////
            this.acct_id_list = [];
            query = "SELECT `" + name + "_acct_id` FROM `" + this.type + "_acct` WHERE " +
              "`" + this.type + "_no` = '" + this.no + "' AND `status` != '0'";
            obj = { cmd: 'getList', query: query };
        
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();
                this.acct_id_list = data.data['list'];
                console.log(this.acct_id_list);
              });
        }
      }

      if (params['inv_no'] != undefined) {
        this.invoice_no = params['inv_no'];

        /////////////////////////////////  Get Customer Account /////////////////////////////////
        query = "SELECT `invoice`.`total`, `invoice`.`tax`, `invoice`.`discount`, `customer`.* FROM " + 
          "`customer`, `invoice` WHERE `invoice`.`invoice_no` = '" + this.invoice_no + 
          "' AND `invoice`.`customer_no` = `customer`.`acct_number`";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let acct_detail = data.data['list'][0];

            this.model['id'] = acct_detail[this.type + '_id']; 
            this.model['paid'] = (Number(acct_detail['total']) + Number(acct_detail['tax']) - Number(acct_detail['discount'])).toString();
            this.model['total'] = this.model['paid'];

            this.from_acct.acct_number = acct_detail['acct_number'];
            this.from_acct.account_type = 'customer';
            this.from_acct.sub_acct_name = acct_detail['acct_number'] + ' - ' + 
              acct_detail['customer_name'] + ' - ' + acct_detail['customer_name_en'];

            this.acct_detail = this.from_acct.sub_acct_name;

            if (this.type == 'cash_receipt') 
              (document.getElementById('search_value_0') as HTMLInputElement).disabled = true;

            this.getInvoiceList();
          });
      }

    });

    if (this.no == '')
      this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    else
      this.add_auth = true;
  }

  // onChangeCustomer = function (acct_number: string) {
  onChangeCustomer = function (search_result: object) {

    console.log(search_result['no']);
    this.model['customer_no'] = search_result['no'];
    this.from_acct.acct_number = search_result['no'];

    if (this.from_acct.acct_number != '') {
      let acct_number = this.from_acct.acct_number;
      if (acct_number.indexOf(this.applicationConstants.main_acct_config['customer']) == 0) {
        this.from_acct.account_type = 'customer';
        this.getInvoiceList();
      }
      else if (acct_number.indexOf(this.applicationConstants.main_acct_config['supplier']) == 0)
        this.from_acct.account_type = 'supplier';
      
      this.from_acct.sub_acct_name = (document.getElementById('search_value_0') as HTMLInputElement).value;
    }
    else {
      this.dp = [];
      this.dataSource = new MatTableDataSource(this.dp);
      this.dataSource.sort = this.sort;
    }
  }

  // onChangeSupplier = function (acct_number: string) {
  onChangeSupplier = function (search_result: object) {
    console.log(search_result['no']);
    this.model['supplier_no'] = search_result['no'];
    this.from_acct.acct_number = search_result['no'];

    if (this.from_acct.acct_number != '') {
      let acct_number = this.from_acct.acct_number;
      if (acct_number.indexOf(this.applicationConstants.main_acct_config['supplier']) == 0) {
        this.from_acct.account_type = 'supplier';
        this.getInvoiceList();
      }
      else if (acct_number.indexOf(this.applicationConstants.main_acct_config['customer']) == 0)
        this.from_acct.account_type = 'customer';
      
      this.from_acct.sub_acct_name = (document.getElementById('search_value_1') as HTMLInputElement).value;
    }
    else {
      this.dp = [];
      this.dataSource = new MatTableDataSource(this.dp);
      this.dataSource.sort = this.sort;
    }
  }

  onChangeCashSearch = function (acct_number: string) {
    this.model['acct_number'] = acct_number;
  }

  onChangeBankSearch = function (acct_number: string) {
    this.model['acct_number'] = acct_number;
    this.model['bank_account_no'] = acct_number;
  }

  getInvoiceList() {
    this.flag = false;
    this.dp = [];
    this.total = 0;
    this.total_amount = 0;

    if (this.model['flag'] != 'update' && this.invoice_no == '') {
      this.model['paid'] = '';
      this.model['total'] = '';
    }

    if ((this.from_acct.account_type == 'customer' && this.model['receipt_type'] == 'cash_receipt') ||
      (this.from_acct.account_type == 'supplier' && this.model['receipt_type'] == 'payment_voucher')) {

      let obj = {
        cmd: 'getInvoiceList', acct_number: this.from_acct.acct_number,
        account_type: this.from_acct.account_type, receipt_no: this.no
      };

      this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          
          let invoice_list = data.status['msg'][0]['invoice_list'];
          this.total_amount = Number(data.status['msg'][0]['total_amount']);

          this.dp = invoice_list;
          this.dataSource = new MatTableDataSource(this.dp); 
          this.dataSource.sort = this.sort;
          
          if (this.from_acct.account_type == 'customer' && this.invoice_no != '') {
            this.dp.forEach(element => {
              if (element.invoice_no == this.invoice_no) {
                if (Number(element.remain_amount) == Number(element.total))
                  element.exist = '1';
                else {
                  this.model['paid'] = element.remain_amount;
                  this.model['total'] = '';
                }
              }
            });
          }
        });
    }
  }

  calc_total(row) {
    if (row.baseline_id == undefined || row.baseline_id == '0' || row.baseline_amount >= 0) {

      if (this.model['flag'] != 'update') {
        let choose = document.getElementById('choose_' + row.invoice_id) as HTMLInputElement;
        let flag = (document.getElementById('flag_' + row.invoice_id) as HTMLInputElement);
        if (choose.checked) {
          this.allUnChecked = false;

          //if (flag.value != 'none') //if the invoice is not paid before
          this.total += Number(row.remain_amount);
          // else
          //   (document.getElementById('flag_' + row.invoice_id) as HTMLInputElement).value = 'update';
          this.model['total'] = this.total.toFixed(2);
          this.model['paid'] = this.total.toFixed(2);
          flag.value = 'new';
        }
        else {
          //if (flag.value != 'none') //if the invoice is not paid before
          this.total -= Number(row.remain_amount);
          // else
          //   (document.getElementById('flag_' + row.invoice_id) as HTMLInputElement).value = 'update';
          this.model['total'] = this.total.toFixed(2);
          this.model['paid'] = this.total.toFixed(2);
          flag.value = '';
        }
      }
      /////////////////////////////// UPDATE ///////////////////////////////
      else {
        let paid = 0;
        let choose;
        this.dp.forEach(element => {
          choose = document.getElementById('choose_' + element.invoice_id) as HTMLInputElement;
          
          if (choose.checked) {
            this.allUnChecked = false;
            paid += Number(element.remain_amount);
          }
        });

        let flag = (document.getElementById('flag_' + row.invoice_id) as HTMLInputElement);
        choose = document.getElementById('choose_' + row.invoice_id) as HTMLInputElement;
        if (flag.value == 'none' && !choose.checked)
          flag.value = 'delete';
        else if ((flag.value == '' || flag.value == 'new') && choose.checked)
          flag.value = 'new';
        else if ((flag.value == '' || flag.value == 'new') && !choose.checked)
          flag.value = '';
        else if ((flag.value == 'delete' || flag.value == 'none') && choose.checked)
          flag.value = 'update';

        this.model['paid'] = paid.toFixed(2);
        this.model['total'] = paid.toFixed(2);
      }
    }
  }

  uncheck() {
    this.total = 0;
    this.model['total'] = '0';
    this.allUnChecked = true;

    this.dp.forEach(element => {
      let choose = document.getElementById('choose_' + element.invoice_id) as HTMLInputElement;
      if (choose.checked) {
        choose.checked = false;
      }
    });
  }

  changeRecType() {
    this.flag = false;
    this.dp = [];
    this.total = 0;
    this.total_amount = 0;
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;
  }

  add() {
    this.saveClicked = true;

    if (Number(this.model['paid']) >= this.total_amount)
      this.flag = true;

    if (this.model['receipt_type'] == '') {
      alert(this.Rec_Type_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.from_acct.acct_number == '') {
      alert(this.Acct_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['paid'] == '' || Number(this.model['paid']) == 0) {
      alert(this.Rec_Amount_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['payment_method'] == '') {
      alert(this.Payment_Method_Msg);
      this.saveClicked = false;
      return;
    }

    if ((this.applicationConstants.user_info.role == 'admin' || 
      this.applicationConstants.user_info.role == 'account') && this.model['payment_method'] == 'cash' && 
      this.model['acct_number'] == '') {
      alert(this.Casher_Acct_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.applicationConstants.user_info.role != 'admin' && this.applicationConstants.user_info.role != 'account' && 
      this.model['payment_method'] == 'cash' && this.applicationConstants.user_info['is_counter'] == '0') {
      alert(this.Not_Counter_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['payment_method'] != 'cash' && this.model['bank_account_no'] == '') {
      alert(this.Bank_Acct_Msg);
      this.saveClicked = false;
      return;
    }

    let query, obj;

    if (this.model['rec_no'] == "")
      this.saveReceipt();
    else {
      if (this.model['receipt_type'] == 'cash_receipt') {
        query = "SELECT * FROM `cash_receipt` WHERE `receipt_no` = '" + this.model['rec_no'] + "'";
        // "' AND `acct_number` = '" + this.from_acct.acct_number + "'";   this.model['composite_type'] != "composite" && 

        if (this.model['flag'] == 'update')
          query += " AND `cash_receipt_no` != '" + this.no + "'";
      }
      else {
        query = "SELECT * FROM `payment_voucher` WHERE `voucher_no` = '" + this.model['rec_no'] + "'";
        // "' AND `acct_number` = '" + this.from_acct.acct_number + "'";

        if (this.model['flag'] == 'update')
          query += " AND `payment_voucher_no` != '" + this.no + "'";
      }
      console.log(query);
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let result = data.data['list'];
          if (result.length > 0) {
            alert(this.Rec_No_Exist_Msg);
            (document.getElementById('rec_no') as HTMLInputElement).focus();
            this.saveClicked = false;
            return;
          }
          else
            this.saveReceipt();
        });
    }
  }

  saveReceipt() {
    let obj;
    let values = [];
    let year, idWhere, prefix;

    if (this.model['receipt_type'] == 'cash_receipt') {

      this.cash_receipt_model['receipt_date'] = (this.model['date'].getFullYear() + "-" +
        (this.model['date'].getMonth() + 1) + "-" + this.model['date'].getDate()
        + ' ' + (new Date()).getHours() + ':' + (new Date()).getMinutes() +
        ':' + (new Date()).getSeconds());

      if (this.model['flag'] != 'update') {
        year = this.model['date'].getFullYear();
        this.cash_receipt_model['year'] = year.toString();
      }
      else 
        this.cash_receipt_model['year'] = this.model['year'];
      this.cash_receipt_model['no'] = this.model['no'];

      // this.cash_receipt_model['cash_receipt_no'] = this.model['no'];
      this.cash_receipt_model['receipt_no'] = this.model['rec_no'];
      this.cash_receipt_model['acct_number'] = this.from_acct.acct_number;
      this.cash_receipt_model['account_type'] = this.from_acct.account_type;
      this.cash_receipt_model['acct_name'] = this.from_acct.sub_acct_name;
      
      if (this.model['payment_method'] != 'cash')
        this.cash_receipt_model['to_acct'] = this.model['bank_account_no'];
      else {
        if (this.applicationConstants.user_info.role == 'admin' || this.applicationConstants.user_info.role == 'account')
          this.cash_receipt_model['to_acct'] = this.model['acct_number'];
        else 
          this.cash_receipt_model['to_acct'] = this.applicationConstants.user_info['acct_number'];
      }
      // this.cash_receipt_model['to_acct'] = (this.model['payment_method'] == 'cash' ? this.model['acct_number'] : this.model['bank_account_no']);
      this.cash_receipt_model['paid'] = this.model['paid'];
      this.cash_receipt_model['payment_method'] = this.model['payment_method'];
      this.cash_receipt_model['check_no'] = this.model['check_no'];
      this.cash_receipt_model['cost_center'] = this.model['cost_center'];
      this.cash_receipt_model['bank_account_no'] = (this.model['payment_method'] == 'bank' ? this.model['bank_account_no'] : ''); // (this.model['composite_type'] == "composite" ? '' : this.model['bank_account_no']);
      this.cash_receipt_model['comment'] = this.model['comment'];
      this.cash_receipt_model['flag'] = this.model['flag'];
      this.cash_receipt_model['cash_receipt_id'] = this.model['id'];

      values.push(this.cash_receipt_model);

      //// add acct list to values 
      // if (this.model['composite_type'] == "composite") {

      values.push({
        'table_name': 'cash_receipt_acct', 'cash_receipt_no': this.cash_receipt_model['cash_receipt_no'],
        'receipt_acct_id': (this.model['flag'] == 'update' ? this.acct_id_list[0]['receipt_acct_id'] : '0'), 
        'flag': this.model['flag'], 'key': 'receipt_acct_id', 'acct_number': this.from_acct.acct_number, 
        'amount': this.model['paid'], 'type': 'from'
      });

      values.push({
        'table_name': 'cash_receipt_acct', 'cash_receipt_no': this.cash_receipt_model['cash_receipt_no'],
        'receipt_acct_id': (this.model['flag'] == 'update' ? this.acct_id_list[1]['receipt_acct_id'] : '0'), 
        'flag': this.model['flag'], 'key': 'receipt_acct_id', 'acct_number': this.cash_receipt_model['to_acct'], 
        'amount': this.model['paid'], 'type': 'to'
      });

      if (this.model['flag'] == 'update')
        obj = { cmd: 'updateAdv', values: values };
      else {
        idWhere = " WHERE `year` = '" + year  + "' AND `branch_id` = '" + this.model['branch_id'] + "'";
        prefix = this.model['branch_id'] + '-' + year + '-';
        obj = {
          cmd: 'add', values: values, pk: 'cash_receipt_no', id: 'no', main_table: 'cash_receipt',
          prefix: prefix, idWhere: idWhere
        };
      }
      // console.log(values);
    }
    else if (this.model['receipt_type'] == 'payment_voucher') {

      this.payment_voucher_model['voucher_date'] = (this.model['date'].getFullYear() + "-" +
        (this.model['date'].getMonth() + 1) + "-" + this.model['date'].getDate()
        + ' ' + (new Date()).getHours() + ':' + (new Date()).getMinutes() +
        ':' + (new Date()).getSeconds());

      if (this.model['flag'] != 'update') {
        year = this.model['date'].getFullYear();
        this.payment_voucher_model['year'] = year.toString();
      }
      else 
        this.payment_voucher_model['year'] = this.model['year'];
      this.payment_voucher_model['no'] = this.model['no'];

      // this.payment_voucher_model['payment_voucher_no'] = this.model['no'];
      this.payment_voucher_model['voucher_no'] = this.model['rec_no'];
      this.payment_voucher_model['acct_number'] = this.from_acct.acct_number;
      this.payment_voucher_model['account_type'] = this.from_acct.account_type;
      this.payment_voucher_model['acct_name'] = this.from_acct.sub_acct_name;

      if (this.model['payment_method'] != 'cash')
        this.payment_voucher_model['from_acct'] = this.model['bank_account_no'];
      else {
        if (this.applicationConstants.user_info.role == 'admin' || this.applicationConstants.user_info.role == 'account')
          this.payment_voucher_model['from_acct'] = this.model['acct_number'];
        else 
          this.payment_voucher_model['from_acct'] = this.applicationConstants.user_info['acct_number'];
      }
      this.payment_voucher_model['paid'] = this.model['paid'];
      this.payment_voucher_model['payment_method'] = this.model['payment_method'];
      this.payment_voucher_model['check_no'] = this.model['check_no'];
      this.payment_voucher_model['cost_center'] = this.model['cost_center'];
      this.payment_voucher_model['bank_account_no'] = (this.model['payment_method'] == 'bank' ? this.model['bank_account_no'] : ''); // (this.model['composite_type'] == "composite" ? '' : this.model['bank_account_no']);
      this.payment_voucher_model['comment'] = this.model['comment'];
      this.payment_voucher_model['flag'] = this.model['flag'];
      this.payment_voucher_model['payment_voucher_id'] = this.model['id'];

      values.push(this.payment_voucher_model);


      values.push({
        'table_name': 'payment_voucher_acct', 'payment_voucher_no': this.payment_voucher_model['payment_voucher_no'],
        'voucher_acct_id': (this.model['flag'] == 'update' ? this.acct_id_list[0]['voucher_acct_id'] : '0'), 
        'flag': this.model['flag'], 'key': 'voucher_acct_id', 'acct_number': this.from_acct.acct_number, 
        'amount': this.model['paid'], 'type': 'to'
      });

      values.push({
        'table_name': 'payment_voucher_acct', 'payment_voucher_no': this.payment_voucher_model['payment_voucher_no'],
        'voucher_acct_id': (this.model['flag'] == 'update' ? this.acct_id_list[1]['voucher_acct_id'] : '0'), 
        'flag': this.model['flag'], 'key': 'voucher_acct_id', 
        'acct_number': this.payment_voucher_model['from_acct'], 'amount': this.model['paid'], 'type': 'from'
      });


      if (this.model['flag'] == 'update')
        obj = { cmd: 'updateAdv', values: values };
      else {
        idWhere = " WHERE `year` = '" + year  + "' AND `branch_id` = '" + this.model['branch_id'] + "'";
        prefix = this.model['branch_id'] + '-' + year + '-';
        obj = {
          cmd: 'add', values: values, pk: 'payment_voucher_no', id: 'no', main_table: 'payment_voucher',
          prefix: prefix, idWhere: idWhere
        };
      }
    }
    console.log(obj);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {
        
          ////////////////////////// Updating is_paid //////////////////////////

          let receipt_no;
          if (this.model['flag'] != 'update')
            receipt_no = data.status['msg']['0']['number'];
          else
            receipt_no = this.no;
          values = [];
          let values1 = [];
          let where = [];
          let obj1;

          if (this.flag) {  // if receipt paid amount will pay all unpaid invoices

            let flag, baseline_id;
            this.dp.forEach(element => {
              flag = document.getElementById('flag_' + element.invoice_id) as HTMLInputElement;

              baseline_id = '0';
              if (element.baseline_id != undefined && element.baseline_id != '0') {
                baseline_id = element.baseline_id;
                element.invoice_no = '';
              }

              if (this.model['receipt_type'] == 'cash_receipt') {

                if (element.invoice_no != '') {
                  where.push({ 'invoice_no': element.invoice_no });
                  if (Number(element.paid_amount) > 0) {
                    values1.push({ 'table_name': 'invoice', 'is_paid': '1' });
                  }
                  else {
                    values1.push({ 'table_name': 'invoice', 'is_paid': '1', 'cash_receipt_no': receipt_no });
                  }
                }

                if (Number(element.remain_amount) > 0) {
                  values.push({
                    'table_name': 'cash_receipt_invoice', 'cash_receipt_no': receipt_no,
                    'invoice_no': element.invoice_no, 'paid_amount': Number(element.remain_amount),
                    'remain_amount': 0, 'flag': flag.value,
                    'receipt_invoice_id': (element.rec_invoice_id != undefined ? element.rec_invoice_id : 0),
                    'key': 'receipt_invoice_id', 'baseline_id': baseline_id
                  });
                }

              }
              else if (this.model['receipt_type'] == 'payment_voucher') {

                if (element.invoice_no != '') {
                  where.push({ 'invoice_no': element.invoice_no });
                  if (Number(element.paid_amount) > 0) {
                    values1.push({ 'table_name': 'supplier_invoice', 'is_paid': '1' });
                  }
                  else {
                    values1.push({ 'table_name': 'supplier_invoice', 'is_paid': '1', 'payment_voucher_no': receipt_no });
                  }
                }

                if (Number(element.remain_amount) > 0) {
                  values.push({
                    'table_name': 'payment_voucher_invoice', 'payment_voucher_no': receipt_no,
                    'invoice_no': element.invoice_no, 'paid_amount': Number(element.remain_amount),
                    'remain_amount': 0, 'flag': flag.value,
                    'voucher_invoice_id': (element.rec_invoice_id != undefined ? element.rec_invoice_id : 0),
                    'key': 'voucher_invoice_id', 'baseline_id': baseline_id
                  });
                }
              }
            });

          }
          else {
            // let checked_invoice = false;
            this.dp.forEach(element => {
              let choose = document.getElementById('choose_' + element.invoice_id) as HTMLInputElement;
              let flag = document.getElementById('flag_' + element.invoice_id) as HTMLInputElement;

              if (choose.checked) {

                let baseline_id = '0';
                if (element.baseline_id != undefined && element.baseline_id != '0') {
                  baseline_id = element.baseline_id;
                  element.invoice_no = '';
                }

                if (this.model['receipt_type'] == 'cash_receipt') {

                  if (element.invoice_no != '') {
                    where.push({ 'invoice_no': element.invoice_no });
                    if (Number(element.paid_amount) > 0) {
                      values1.push({ 'table_name': 'invoice', 'is_paid': '1' });
                    }
                    else {
                      values1.push({ 'table_name': 'invoice', 'is_paid': '1', 'cash_receipt_no': receipt_no });
                    }
                  }

                  if (Number(element.remain_amount) > 0) {
                    values.push({
                      'table_name': 'cash_receipt_invoice', 'cash_receipt_no': receipt_no,
                      'invoice_no': element.invoice_no, 'paid_amount': Number(element.remain_amount),
                      'remain_amount': 0, 'flag': flag.value,
                      'receipt_invoice_id': (element.rec_invoice_id != undefined ? element.rec_invoice_id : 0),
                      'key': 'receipt_invoice_id', 'baseline_id': baseline_id
                    });
                  }

                }
                else if (this.model['receipt_type'] == 'payment_voucher') {

                  if (element.invoice_no != '') {

                    where.push({ 'invoice_no': element.invoice_no });
                    if (Number(element.paid_amount) > 0) {
                      values1.push({ 'table_name': 'supplier_invoice', 'is_paid': '1' });
                    }
                    else {
                      values1.push({
                        'table_name': 'supplier_invoice', 'is_paid': '1',
                        'payment_voucher_no': receipt_no
                      });
                    }
                  }

                  if (Number(element.remain_amount) > 0) {
                    values.push({
                      'table_name': 'payment_voucher_invoice', 'payment_voucher_no': receipt_no,
                      'invoice_no': element.invoice_no, 'paid_amount': Number(element.remain_amount),
                      'remain_amount': 0, 'flag': flag.value,
                      'voucher_invoice_id': (element.rec_invoice_id != undefined ? element.rec_invoice_id : 0),
                      'key': 'voucher_invoice_id', 'baseline_id': baseline_id
                    });
                  }

                }
              }
              else if (!this.allUnChecked && !choose.checked && this.model['flag'] == 'update') {
                
                if (element.rec_invoice_id != undefined && element.rec_invoice_id != '0') {

                  if (element.invoice_no != '') {
                    where.push({ 'invoice_no': element.invoice_no });
                    if (this.model['receipt_type'] == 'cash_receipt') {
                      if (Number(element.paid_amount) > 0) {
                        values1.push({ 'table_name': 'invoice', 'is_paid': '0' });
                      }
                      else {
                        values1.push({ 'table_name': 'invoice', 'is_paid': '0', 'cash_receipt_no': '' });
                      }
                    }
                    else if (this.model['receipt_type'] == 'payment_voucher') {
                      if (Number(element.paid_amount) > 0) {
                        values1.push({ 'table_name': 'supplier_invoice', 'is_paid': '0' });
                      }
                      else {
                        values1.push({ 'table_name': 'supplier_invoice', 'is_paid': '0', 'payment_voucher_no': '' });
                      }

                    }
                  }


                  if (this.model['receipt_type'] == 'cash_receipt') {
                    where.push({ 'receipt_invoice_id': element.rec_invoice_id });
                    values1.push({ 'table_name': 'cash_receipt_invoice', 'status': '0' });
                  }
                  else if (this.model['receipt_type'] == 'payment_voucher') {
                    where.push({ 'voucher_invoice_id': element.rec_invoice_id });
                    values1.push({ 'table_name': 'payment_voucher_invoice', 'status': '0' });
                  }

                }
              }
            });

            if (this.allUnChecked) {
              let remain_paid = Number(this.model['paid']);
              let paid_amount, remain_amount;
              let flag, rec_invoice_id, baseline_id;

              this.dp.forEach(element => {
                if (element.baseline_id == undefined || element.baseline_id == '0' || (element.baseline_id != undefined && Number(element.remain_amount) > 0)) {
                  if (remain_paid > 0) {
                    // console.log(element);

                    paid_amount = (remain_paid >= Number(element.remain_amount) ? Number(element.remain_amount) : remain_paid);
                    remain_amount = (remain_paid >= Number(element.remain_amount) ? 0 : (Number(element.remain_amount) - remain_paid));
                    remain_paid -= paid_amount;

                    baseline_id = '0';
                    if (element.baseline_id != undefined && element.baseline_id != '0') {
                      baseline_id = element.baseline_id;
                      element.invoice_no = '';
                    }

                    if (element.rec_invoice_id == undefined || element.rec_invoice_id == '0') {
                      flag = 'new';
                      rec_invoice_id = '0';
                    }
                    else {
                      flag = 'update';
                      rec_invoice_id = element.rec_invoice_id;
                    }

                    if (this.model['receipt_type'] == 'cash_receipt') {

                      values.push({
                        'table_name': 'cash_receipt_invoice', 'cash_receipt_no': receipt_no, 'flag': flag,
                        'receipt_invoice_id': rec_invoice_id, 'key': 'receipt_invoice_id',
                        'invoice_no': element.invoice_no, 'paid_amount': paid_amount,
                        'remain_amount': remain_amount, 'baseline_id': baseline_id
                      });


                      if (remain_amount == 0 && element.invoice_no != '') {  // paid the remain_amount of invoice

                        where.push({ 'invoice_no': element.invoice_no });

                        if (Number(element.paid_amount) > 0)
                          values1.push({ 'table_name': 'invoice', 'is_paid': '1' });
                        else
                          values1.push({ 'table_name': 'invoice', 'is_paid': '1', 'cash_receipt_no': receipt_no });
                      }
                      else if (remain_amount > 0 && flag == 'update' && element.invoice_no != '') {
                        where.push({ 'invoice_no': element.invoice_no });
                        values1.push({ 'table_name': 'invoice', 'is_paid': '0', 'cash_receipt_no': '' });
                      }
                    }
                    else if (this.model['receipt_type'] == 'payment_voucher') {

                      // insert invoice to payment_voucher_invoice table 

                      values.push({
                        'table_name': 'payment_voucher_invoice', 'payment_voucher_no': receipt_no, 'flag': flag,
                        'voucher_invoice_id': rec_invoice_id,
                        'key': 'voucher_invoice_id', 'invoice_no': element.invoice_no, 'paid_amount': paid_amount,
                        'remain_amount': remain_amount, 'baseline_id': baseline_id
                      });


                      if (remain_amount == 0 && element.invoice_no != '') {  // paid the remain_amount of invoice
                        where.push({ 'invoice_no': element.invoice_no });
                        if (Number(element.paid_amount) > 0)
                          values1.push({ 'table_name': 'supplier_invoice', 'is_paid': '1' });
                        else
                          values1.push({ 'table_name': 'supplier_invoice', 'is_paid': '1', 'payment_voucher_no': receipt_no });
                      }
                      else if (remain_amount > 0 && flag == 'update' && element.invoice_no != '') {
                        where.push({ 'invoice_no': element.invoice_no });
                        values1.push({ 'table_name': 'supplier_invoice', 'is_paid': '0', 'payment_voucher_no': '' });
                      }
                    }
                  }
                  else if (this.model['flag'] == 'update') {
                    if (element.rec_invoice_id != undefined && element.rec_invoice_id != '0') {
                      baseline_id = '0';
                      if (element.baseline_id != undefined && element.baseline_id != '0') {
                        baseline_id = element.baseline_id;
                        element.invoice_no = '';
                      }

                      flag = 'delete';

                      if (this.model['receipt_type'] == 'cash_receipt') {
                        values.push({
                          'table_name': 'cash_receipt_invoice', 'cash_receipt_no': receipt_no, 'flag': flag,
                          'receipt_invoice_id': element.rec_invoice_id, 'key': 'receipt_invoice_id',
                          'invoice_no': element.invoice_no, 'paid_amount': element.paid_amount,
                          'remain_amount': element.remain_amount, 'baseline_id': baseline_id
                        });

                        where.push({ 'invoice_no': element.invoice_no });
                        values1.push({ 'table_name': 'invoice', 'is_paid': '0', 'cash_receipt_no': '' });
                      }
                      else if (this.model['receipt_type'] == 'payment_voucher') {
                        values.push({
                          'table_name': 'payment_voucher_invoice', 'payment_voucher_no': receipt_no, 'flag': flag,
                          'voucher_invoice_id': element.rec_invoice_id, 'key': 'voucher_invoice_id',
                          'invoice_no': element.invoice_no, 'paid_amount': element.paid_amount,
                          'remain_amount': element.remain_amount, 'baseline_id': baseline_id
                        });

                        where.push({ 'invoice_no': element.invoice_no });
                        values1.push({ 'table_name': 'supplier_invoice', 'is_paid': '0', 'payment_voucher_no': '' });
                      }
                    }

                  }
                }


              });
            }
          }

          if (values.length > 0) {

            obj = { cmd: 'updateAdv', values: values };
            console.log(obj);
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                if (data.status['type'] == 'success') {
                  if (values1.length > 0) {

                    obj1 = { cmd: 'update', values: values1, where: where };
                    console.log(obj1);
                    this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
                      .subscribe(data => {
                        this.applicationConstants.appComp.hideBusyCursor();

                        if (data.status['type'] == 'success') {
                          alert(this.Success_Msg + this.Rec_No_Msg + ' ' + receipt_no);
                          this.router.navigate(['sub_menu/3/receipt_list']);
                        }
                        else {
                          alert(this.Error_Msg);
                          this.saveClicked = false;
                        }

                      });
                  }
                  else {
                    alert(this.Success_Msg + this.Rec_No_Msg + ' ' + receipt_no);
                    this.router.navigate(['sub_menu/3/receipt_list']);
                  }
                }
                else {
                  alert(this.Error_Msg);
                  this.saveClicked = false;
                }

              });
          }
          else {
            alert(this.Success_Msg + this.Rec_No_Msg + ' ' + receipt_no);
            this.router.navigate(['sub_menu/3/receipt_list']);
          }
          window.open(this.applicationConstants.generatePDF + "?receipt_type=" + this.model['receipt_type'] + 
            "&receipt_no=" + receipt_no + "&lang=" + this.applicationConstants.user_lang, "_blank");
          // this.dialogRef.close(this.dialog_data);
        }
        else {
          alert(this.Error_Msg);
          this.saveClicked = false;
        }
      });
  }

}
